export default __webpack_public_path__ + "static/media/right_leaf.0739e8b5.png";